import { ApplyButton, CancelButton, EditButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Divider, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { confirmarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext/GlobalContext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaBuilding } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EmpresaModais } from '../EmpresaModais';
import ContatoVisualizar from './ContatoVisualizar';
import DadosGeraisVisualizar from './DadosGeraisVisualizar';
import EnderecoVisualizar from './EnderecoVisualizar';
import TributacaoVisualizar from './TributacaoVisualizar';

const FormEmpresaVisualizacao = ({ empresa }) => {
  const [expanded, setExpanded] = useState('dadosGerais');
  const { endereco, contatos } = empresa?.pessoa || {};

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <ExpansionPanel expanded={expanded === 'dadosGerais'} onChange={handleChange('dadosGerais')}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ marginRight: 16, fontWeight: 700, textTransform: 'initial' }} variant="button">
            Dados Gerais
          </Typography>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <DadosGeraisVisualizar dadosGerais={empresa} />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel expanded={expanded === 'tributacao'} onChange={handleChange('tributacao')}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ marginRight: 16, fontWeight: 700, textTransform: 'initial' }} variant="button">
            Tributação
          </Typography>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <TributacaoVisualizar tributacao={empresa} />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel expanded={expanded === 'endereco'} onChange={handleChange('endereco')}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ marginRight: 16, fontWeight: 700, textTransform: 'initial' }} variant="button">
            Endereço
          </Typography>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <EnderecoVisualizar endereco={endereco} />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ marginRight: 16, fontWeight: 700, textTransform: 'initial' }} variant="button">
            Contato
          </Typography>
        </ExpansionPanelSummary>
        <Divider />
        <ExpansionPanelDetails>
          <ContatoVisualizar contato={contatos} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
};

const EmpresaVisualizacaoModal = ({ isOrigemEmpresa, modal, setModalContextoEmpresa = () => {} }) => {
  const [modalEmpresa, setModalEmpresa] = useContext(GlobalContext).modalEmpresa;
  const [empresa, setEmpresa] = useContext(GlobalContext).empresa;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);
  const [, setModal] = useContext(GlobalContext).modal;

  const history = useHistory();

  useReduxLoading(loading);

  const empresaCadastroDefault = {
    pessoa: {
      tipoPessoa: 'JURIDICA',
    },
    ativo: true,
  };

  const chamarModalAlterarPlano = () => {
    setModal(EmpresaModais.alteracaoPlanoComercial);
  };

  const confirmarAlteracaoPlano = () => {
    confirmarAlert({
      confirmar: chamarModalAlterarPlano,
      titulo: 'Seu plano atual não permite cadastro de mais empresas.',
      mensagem: 'Você deseja conhecer mais sobre esses planos?',
    });
  };

  const handleNovoCadastroModal = async () => {
    try {
      setLoading(true);
      await empresaApi.limiteEmpresa(false);
      setEmpresa(empresaCadastroDefault);
      history.push('/empresa');
      handleCloseModal();
    } catch (err) {
      setLoading(false);
      confirmarAlteracaoPlano();
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModalEmpresa(false);
    setModalContextoEmpresa('');
  };

  const handleCadastroModal = async () => {
    setModalContextoEmpresa(EmpresaModais.cadastrarEmpresa);
    setModalEmpresa(EmpresaModais.cadastrarEmpresa);
  };

  async function buscarEmpresa() {
    try {
      setLoading(true);
      const respEmpresa = await empresaApi.buscar(getEmpresaContexto());

      if (respEmpresa?.data?.logomarcaId) {
        const logomarca = await empresaApi.buscarLogoMarca(respEmpresa?.data?.logomarcaId);
        if (logomarca?.data?.content) {
          respEmpresa.data.logomarca = `data:image/jpeg;charset=utf-8;base64,${logomarca?.data?.content}`;
        }
      }

      setEmpresa(respEmpresa.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    buscarEmpresa();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SimpleDialog
      open={modalEmpresa === EmpresaModais.visualizarEmpresa || modal === EmpresaModais.visualizarEmpresa}
      onClose={handleCloseModal}
    >
      <SimpleDialogContent
        header={{
          title: 'Minha empresa',
          icon: <FaBuilding />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {!isOrigemEmpresa && permissaoUtils.minhaEmpresa().cadastrar && (
                <ApplyButton onClick={handleNovoCadastroModal}>Cadastrar nova empresa</ApplyButton>
              )}
              {permissaoUtils.minhaEmpresa().editar && (
                <EditButton color="buttonSave" onClick={handleCadastroModal}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        content={<FormEmpresaVisualizacao empresa={empresa} />}
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default EmpresaVisualizacaoModal;
